import { ActionTree } from "vuex";
import * as types from "./types";
import api from "../api";
import router from "@/router";
import {PublicClientApplication} from "@azure/msal-browser";
import {CacheLookupPolicy} from "@azure/msal-browser/dist/utils/BrowserConstants";

export interface LoginActionPayload {
    username: string;
    password: string;
    logonType?: string;
}

export default <ActionTree<account.state.AccountState, RootState>>{
    async [types.LOGIN](action, payload: LoginActionPayload) {
        const result = await api.auth.login(payload.username, payload.password);
        action.commit(types.CURRENT, result);
        return result;
    },
    async [types.EUMLOGIN](action, payload: LoginActionPayload) {
        let logonType = payload.logonType ? payload.logonType : "";
        const result = await api.auth.eumLogin(payload.username, payload.password, logonType);
        action.commit(types.CURRENT, result);
        return result;
    },
    async [types.LOGINEX](action, payload: LoginActionPayload) {
        const result = await api.auth.loginex(payload.username);
        action.commit(types.CURRENT, result);
        return result;
    },

    async [types.LOGINHINT](action, payload: LoginActionPayload) {
        const result = await api.auth.loginHint(payload.username);
        action.commit(types.CURRENT, result);
        return result;
    },

    async [types.LOGINASSERTION](action, payload: { tenantId: string; idToken: string }) {
        const result = await api.auth.loginAssertion(payload.tenantId, payload.idToken);
        action.commit(types.CURRENT, result);
        return result;
    },

    async [types.CURRENT](action, payload) {
        const result = await api.account.getCurrentUser();
        action.commit(types.CURRENT, result);
        return result;
    },

    async [types.LOGOUT](action, payload) {
        const result = await api.auth.logout();
        action.commit(types.CURRENT, null);
        router.push({ name: "account-login" });
        return result;
    },

    async [types.MS_ACCESSTOKEN](action) {
        let azureInfo = await api.auth.getIdentityAzureInfo();
        let msal = new PublicClientApplication({
            auth: {
                clientId: azureInfo.applicationID,
                authority: `https://login.microsoftonline.com/${azureInfo.tenantId}`,
                navigateToLoginRequestUrl: true,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: true
            },
        });

        let account = msal.getActiveAccount();
        if(account){
            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account,
                cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken
            };

            return msal.acquireTokenSilent(accessTokenRequest).then(function (accessTokenResponse) {
                // Acquire token silent success
                let idToken = accessTokenResponse.idToken;
                action.commit(types.MS_ACCESSTOKEN, idToken);
                return idToken;
            })
            .catch(function (error) {
                console.log(error);
                return null;
            });

        }

        return null;

    },

    async [types.MS_ACCESSTOKEN_FORCE](action) {
        let azureInfo = await api.auth.getIdentityAzureInfo();
        let msal = new PublicClientApplication({
            auth: {
                clientId: azureInfo.applicationID,
                authority: `https://login.microsoftonline.com/${azureInfo.tenantId}`,
                navigateToLoginRequestUrl: true,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: true
            },
        });

        let account = msal.getActiveAccount();
        if(account){
            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account,
                forceRefresh: true
            };

            return msal.acquireTokenSilent(accessTokenRequest)
                .then(function (accessTokenResponse) {
                    // Acquire token silent success
                    let idToken = accessTokenResponse.idToken;
                    action.commit(types.MS_ACCESSTOKEN, idToken);
                    return idToken;
                })
                .catch(function (error) {
                    console.log(error);
                    return null;
                });

        }

        return null;

    }
};
